import { Component, Input, OnInit } from '@angular/core';
import { NavigationStart, Router, ActivatedRoute } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import { ViewChild } from '@angular/core';
import { UtilityService } from '../service/utility.service';
import { Globals } from '../service/global';
import { environment, layoutTourValues } from 'src/environments/environment';
import { MeetingService } from '../service/meeting.service';
import { AttendeeService } from '../service/attendee.service';
import { TooltipPosition } from '@angular/material/tooltip';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CreateMeetingComponent } from '../../app/screens/create-meeting/create-meeting.component';
import { PreviousMeetingHistoryDialogComponent } from '../components/previous-meeting-history-dialog/previous-meeting-history-dialog.component';
import { CodeList } from '../models/basicMeetingModel';
import { SideNavServiceService } from '../service/side-nav-service.service';
import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { ShortcutDialogComponent } from '../components/shortcut-dialog/shortcut-dialog.component';
import { JoyrideService } from 'ngx-joyride';
import { TourDialogComponent } from '../components/tour-dialog/tour-dialog.component';
import { VideoTourComponent } from '../components/video-tour/video-tour.component';
import { fromEvent, Subscription, interval } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { DashboardService } from '../service/dashboard.service';
import { TaskComponent } from '../components/task/task.component';
import { map } from 'jquery';
import { NotifierService } from 'angular-notifier';
import { PermissionService } from '../service/permission.service';
import moment from 'moment';
import { AuthenticationService } from '../service/authentication.service';
import { ReportService } from '../service/report.service';
import { GrapesjsEditorComponent } from '../components/grapesjs-editor/grapesjs-editor.component';
import { WebsocketService } from '../service/websocket.service';
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {

  @Input()
  deviceXs!: boolean;

  @Input()
  deviceSm!: boolean;

  @Input()
  deviceMd!: boolean;

  @Input()
  deviceLg!: boolean;

  @Input()
  deviceXl!: boolean;

  disabled = false;
  compact = true;
  invertX = false;
  invertY = false;
  
  componentName='HomePage';
  userName:any;
  fullScreenRemoved = false;
  marqueeNotificationData: any = []

  meetingJsonData: any = [];
  taskJsonData: any = [];

  shown: 'native' | 'hover' | 'always' = 'native';

  meetingObj: any = {};

  horizontalPosition: MatSnackBarHorizontalPosition = 'start';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';
  //UI Team change
  loggedUserDetails:any;
  globalSearchText: any
  subscriptions!: Subscription;
  lastName:any;
  intervalId!: number;
  reportUserId!:string;
  loggedUserId:any;

  layoutTourValues = layoutTourValues
  notificationData: any = [];
  phemeRights:boolean=true;
  phemeReportRights:boolean=true;
  reportUserId2!:string;

  constructor(private authService:AuthenticationService ,private permissionService:PermissionService,private dashBoardService:DashboardService,private readonly joyrideService: JoyrideService,public sideNav : SideNavServiceService,public router : Router,private utilityService: UtilityService, private globals: Globals,private meetingService: MeetingService,private attendeeService:AttendeeService,public dialog: MatDialog,private spinner: NgxSpinnerService,private route: ActivatedRoute, private notifierService:NotifierService,public report:ReportService, private websocketService: WebsocketService) {
    
    this.authService.currentUserValue

    this.authService.getloggedUserValue().subscribe((userLoggedIn:any) => {
      
      if (userLoggedIn!=null) {
   
        this.phemeRights = this.permissionService.checkPhemeRightsWithNoAlert(this.utilityService.featureList.PHEME, this.utilityService.permissionType.READ,userLoggedIn);
        var userData={
          loginName : userLoggedIn.loginName,
          loginKey : userLoggedIn.loginKey,
          source : "DS_AgoraReports_1",
         }
        this.report.getAllReports(userData).subscribe(data=>{
          this.phemeReportRights=true;
        },error=>{
          this.phemeReportRights=false;
        })

  
      }
    })
    this.showMeetingMenu = true;
    this.userName=localStorage.getItem('userName')
  }

  //instant meeting dropdown button disable variable
  instantMeetingButtonDisable = false;

  @ViewChild('sidenav') sidenav: any;
  taskStatusList!: CodeList;
  isExpanded = false;
  showSubmenu: boolean = false;
  isShowing = false;
  showSubSubMenu: boolean = false;
  positionOptions: TooltipPosition[] = ['below', 'above', 'left', 'right'];
  position = new UntypedFormControl(this.positionOptions[0]);
  backdrop = false
  showHeader: boolean = false;
  showMeetingMenu: boolean = true;
  notificationJSON: any = []
  pathName : any

  mouseenter() {
    if (!this.isExpanded) {
      this.isShowing = false;
    }

  }

  addMargin(bool: any) {
    if (bool && (this.deviceXl || this.deviceLg)) {
      document.getElementsByClassName('example-sidenav-content')[0].setAttribute('style', 'margin-left : 84px')
    }
    else {
      document.getElementsByClassName('example-sidenav-content')[0].removeAttribute('style')
    }
  }

  mouseleave() {
    if (!this.isExpanded) {
      this.isShowing = false;
    }
  }

  openDialog() {
    if (localStorage.getItem('isGuest') != undefined && localStorage.getItem('isGuest') != null && localStorage.getItem('isGuest') == '1') {
      this.notifierService.notify("warning", "User doesn't have rights");
      this.showMeetingMenu = false;
    }
  }

  toggleSideNav() {
    this.sidenav.toggle();
    this.isExpanded = !this.isExpanded
  }
  scheduleMeeting() {
    return this.router.navigate(['schedule']);
  }

  //dashboard navigator
  dashboardNavigator() {

    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.utilityService.featureList.MEETINGS, this.utilityService.permissionType.READ);
    
    if (!accessFlag) {
      return;
    }
    this.sideNav.openInstantMeeting(false)
    this.spinner.show();
    this.router.navigate(['dashboard'])
    this.spinner.hide();
    this.dialog.closeAll()
    this.sideNav.pinShortCutDialog(false)
  }

  // Teams Sync navigator (route to page similar to other pages)
  teamsSyncNavigator() {
    this.spinner.show();
    this.router.navigate(['/teams-sync'])
    this.spinner.hide();
    this.dialog.closeAll()
    this.sideNav.pinShortCutDialog(false)
  }

  //Meetings navigator
  meetingNavigator() {

    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.utilityService.featureList.MEETINGS, this.utilityService.permissionType.READ);
    
    if (!accessFlag) {
      return;
    }
    this.spinner.show();
    this.router.navigate(['/events'])
    this.spinner.hide();
    this.dialog.closeAll()
    this.sideNav.pinShortCutDialog(false)
  }
  //shortcuts Navigator
  shortcutsNavigator() {
    this.dialog.open(ShortcutDialogComponent, {
      panelClass: ['animate__animated', 'animate__slideInRight'],
      disableClose: false,
      position: {
        left: "85%"
      },
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "20%",
      height: "100vh",
      hasBackdrop: false
    });
  }

  openHelpVideo() {
    this.router.navigate(['help'])
  }

  //task Navigator
  taskNavigator() {

    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.utilityService.featureList.SEARCH, this.utilityService.permissionType.READ);
    
    if (!accessFlag) {
      return;
    }
    this.spinner.show();
    this.router.navigate(['/tasks'])
    this.spinner.hide();
    this.dialog.closeAll()
    this.sideNav.pinShortCutDialog(false)
  }

  //search navigator
  searchNavigator() {

    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.utilityService.featureList.SEARCH, this.utilityService.permissionType.READ);
    
    if (!accessFlag) {
      return;
    }
    this.spinner.show();
    if (localStorage.getItem('isGuest') != null && localStorage.getItem('isGuest') == '1') {
      this.notifierService.notify("warning", "User doesn't have rights");
    } else {
      this.router.navigate(['/search']);
    }
    this.spinner.hide();
    this.dialog.closeAll()
    this.sideNav.pinShortCutDialog(false)
  }

  //settings navigator
  settingsNavigator() {

    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.utilityService.featureList.MEETINGS, this.utilityService.permissionType.READ);
    
    if (!accessFlag) {
      return;
    }
    this.spinner.show();
    this.router.navigate(['/settings'])
    this.spinner.hide();
    this.dialog.closeAll()
    this.sideNav.pinShortCutDialog(false)

  }


  pheme(){
    this.spinner.show();
    this.router.navigate(['/pheme']) 
    this.spinner.hide();
    this.dialog.closeAll()
    this.sideNav.pinShortCutDialog(false)
  }

  phemeReports(){
    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.utilityService.featureList.PHEMEREPORT, this.utilityService.permissionType.READ);
    
    if (!accessFlag) {
      return;
    }
    this.spinner.show();
    this.router.navigate(['phemeReports']);
    this.spinner.hide();
    this.dialog.closeAll()
    this.sideNav.pinShortCutDialog(false)
  }

  //profile navigator
  profileNavigator() {

    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.utilityService.featureList.MEETINGS, this.utilityService.permissionType.READ);
    
    if (!accessFlag) {
      return;
    }
    this.spinner.show();
    this.router.navigate(['/profile'])
    this.spinner.hide();
    this.dialog.closeAll()
    this.sideNav.pinShortCutDialog(false)
  }

  useTemplate() {
    this.dialog.open(CreateMeetingComponent)
  }

  createNewMeeting(instantMeetingActivation: any, meetingInternalType: string) {
    this.spinner.show();
    this.meetingObj = {};
    var meetingStartTime: any;
    this.sideNav.enableAfterApproveToNormal();
    if (meetingInternalType == "I") {
      meetingStartTime = this.utilityService.nvl(this.utilityService.getDefaultInstantTime());
    } else {
      meetingStartTime = this.utilityService.nvl(this.utilityService.getDefaultMeetingTime());
    }

    this.meetingObj = {
      "meetingDateStr": this.utilityService.nvl(this.utilityService.getDefaultMeetingDate()),
      "meetingStartTime": meetingStartTime,
      "orgCode": this.globals.orgCode,
      "userId": this.globals.userId,
      "visitorTimeZone": this.globals.vTimeZone,
      "duration": environment.defMeetingDuration,
      "logType": this.globals.logType
    }
      
      this.sideNav.openInstantMeeting(instantMeetingActivation);
      if(this.sideNav.openInstantMeetingTransmitter() == true){
         this.meetingObj.meetingTitle = environment.instantMeeting
       //  window.alert("instant meeting")
      }
      else {
        this.meetingService.getCategoryDetails().subscribe(response => {
         
          this.router.navigate(['templateView'],{queryParams:  {'response':response,'meetingType':meetingInternalType},skipLocationChange: true, replaceUrl: false})
          // window.history.replaceState('','','/schedule')
        })
        this.spinner.hide();
        // this.meetingObj.meetingTitle = environment.defMeetingTitle
        // window.alert("schedule meeting") 
      }
      this.instantMeetingButtonDisable = this.sideNav.openInstantMeetingTransmitter()
      
      if(meetingInternalType=="I"){
        this.meetingObj.meetingStartFlag = "Y";
      }
      //
      // alert("meetingObj"+JSON.stringify(this.meetingObj));
      //this.ngxSpinner.show();
      if(meetingInternalType != 'S'){
        
      this.meetingService.createNewMeeting(this.meetingObj).subscribe(data => {
       
        if (data != null && data != undefined && data.body != null && data.body != undefined) {
          if (data.body.meetingId != null) {
            ////consolee.log("meeting>>" + JSON.stringify(data.body));
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = 'reload';
            this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify({ "meetingId": data.body.meetingId, "isMeetingRunning": true }) }, skipLocationChange: true, replaceUrl: false });
            // window.history.replaceState('','','/instant')
          }
          //this.notifier.notify("success", "Meeting Scheduled successfully");
        }
        this.spinner.hide();
        //this.ngxSpinner.hide();
      },
        err => {
          //
          this.spinner.hide();
          //this.ngxSpinner.hide();
        }).add(() => {
          //Called when operation is complete (both success and error)
        });
    }

    // }


  }
  //Method to enter into meeting
  fetchMeeting(meetingId: any) {
    if (this.sideNav.openInstantMeetingTransmitter() == true) {
      this.sideNav.alertSnackBar("The meeting started...")
    }
    else {
      this.sideNav.openInstantMeeting(true);
      this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify({ "meetingId": 41235 }) }, skipLocationChange: true, replaceUrl: false });
    }
  }

  //activate user
  activateUser() {
    this.spinner.show();
    this.router.navigate(['activateUser'])
  }

  //show instant meeting alert


  ngDoCheck() {
    this.instantMeetingButtonDisable = this.sideNav.openInstantMeetingTransmitter()
    //UI Team current change for login name showing
    // //
  }

  ngOnChanges() {
    if(this.deviceMd || this.deviceSm || this.deviceXs){
      this.addMargin(false)
    }
    else if(this.isExpanded){
      this.isExpanded = false
    }
    document.addEventListener('fullscreenchange', () => {
      if (document.fullscreenElement == null) {
        this.sideNav.expandBrowserFullScreenSetter(false)
        if(this.sideNav.returnVideoFullScreenExpansionSetter()){
          this.sideNav.videoFullScreenExpansionSetter(false, '')
        }
      }
      this.addMargin(false)
      this.isExpanded = false
    })
  }


  ngOnInit(): void {
 
    localStorage.clear();
 
    this.showMeetingMenu = true;
    this.loggedUserDetails = localStorage
    this.reportUserId="154";
    this.reportUserId2="148";


    this.router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        //
        this.pathName = event['url'].split('?')![0]
        if (event['url'] == '/' || event['url'] == '' || event.url.includes('passwordCreation') || event.url.includes('/login') || event.url.includes('forgotPassword') || event.url.includes('/?open=signup')) {
          this.showHeader = false;
          // if(event.url.includes('passwordCreation')){
          //   //
          //   window.alert("called")
          // }
        } else {
          // this.spinner.show();
          var reqJson = {

            "pageCode": "NOTITY",
            "timeZone": localStorage.getItem("timeszone"),
            "userId": localStorage.getItem('userId')
          }

          
           this.showHeader = true;

         }
      } 
    });


  }

  notificationCall(text: any) {

    var reqJson = {

      "pageCode": "NOTITY",
      "timeZone": localStorage.getItem("timeszone"),
      "userId": localStorage.getItem('userId')
    }

  }
  xl = {
    panelClass: ['animate__animated', 'animate__slideInRight'],
    position: {
      left: "50%"
    },
    maxWidth: "100%",
    maxHeight: "100vh",
    width: "50%",
    height: "100vh",
    overflow: "hidden"
  }

  lg = {
    panelClass: ['animate__animated', 'animate__slideInRight'],
    position: {
      left: "50%"
    },
    maxWidth: "100%",
    maxHeight: "100vh",
    width: "50%",
    height: "100vh",
    overflow: "hidden"
  }

  md = {
    panelClass: ['animate__animated', 'animate__slideInRight'],
    position: {
      left: "30%"
    },
    maxWidth: "100%",
    maxHeight: "100vh",
    width: "50%",
    height: "100vh",
    overflow: "hidden"
  }

  sm = {
    panelClass: ['animate__animated', 'animate__slideInRight'],
    position: {
      left: "20%"
    },
    width: "calc(100% - 100px)",
    height: "calc(100% - 0px)",
  }

  xs = {
    panelClass: ['animate__animated', 'animate__slideInRight'],
    position: {
      left: "20%"
    },
    width: "calc(100% - 0px)",
    height: "calc(100% - 0px)",
  }

  previosMeetingDialog() {
    // this.dialog.open(InstantPreviousMeetingDialogComponent, {
    //   panelClass: ['animate__animated','animate__slideInRight'],
    //   position : {
    //     left : "50%"
    //   },
    //   width : "700px",
    //   height : "700px",
    // })
    if (this.deviceLg) {
      this.dialog.open(PreviousMeetingHistoryDialogComponent, this.lg)
    }
    if (this.deviceMd) {
      this.dialog.open(PreviousMeetingHistoryDialogComponent, this.md)
    }
    if (this.deviceSm) {
      this.dialog.open(PreviousMeetingHistoryDialogComponent, this.sm)
    }
    if (this.deviceXs) {
      this.dialog.open(PreviousMeetingHistoryDialogComponent, this.xs)
    }
    if (this.deviceXl) {
      this.dialog.open(PreviousMeetingHistoryDialogComponent, this.xl)
    }
  }

  logOutUser() {
    this.authService.logout();
    localStorage.removeItem("userId");
    localStorage.removeItem("userName");
    localStorage.removeItem("currentUser");
    localStorage.clear();
    this.globals.settingValuesList = undefined;
    this.router.navigate([''])
    this.sideNav.alertLogout("Logout");
    this.websocketService._disconnect()
    this.subscriptions.unsubscribe();

  }

  alertTrigger() {
    window.alert("Guest user not allowed")
  }

  openTour() {
    this.dialog.open(TourDialogComponent, {
      disableClose: true,
      panelClass: ['parent-dialog-container'],
      maxWidth: "100%",
      maxHeight: "100vh",
      minWidth: "50%",
      minHeight: "40vh",
    })
  }

  searchText(event: any) {
    this.globalSearchText = event.target.value
  }

  keyWordSearch(text: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    if (text != null && text != "" && text != undefined) {
      //this.router.navigate(['tasks'], { queryParams: {"data" : text}, skipLocationChange: true, replaceUrl: false });  
      this.router.navigate(['search'], { queryParams: { "data": text }, skipLocationChange: true, replaceUrl: false });
    } else {
      text = "";

      this.router.navigate(['search'], { queryParams: { "data": text }, skipLocationChange: true, replaceUrl: false });
    }

    var storageVal: any = localStorage.getItem("searchValue");
    if (storageVal != undefined && storageVal != null && storageVal != "" && storageVal != "{}") {
      var jsonObj = JSON.parse(storageVal);
      jsonObj.globalSearchTxt = text;
      localStorage.setItem("searchValue", JSON.stringify(jsonObj));
    } else {
      localStorage.setItem("searchValue", JSON.stringify({ "globalSearchTxt": text }));
    }

  }

  openVideoTour() {
    this.dialog.open(VideoTourComponent, {
      disableClose: true,
      panelClass: ['parent-dialog-container'],
      maxWidth: "100%",
      maxHeight: "100vh",
      minWidth: "50%",
      minHeight: "40vh",
    })
  }

  navigateMeeting(meetingId :any){
   
  }
  reports(){
    this.router.navigate(['report'])
  }

clearSearchText() {
    this.globalSearchText = ""
    localStorage.setItem("searchValue", "");
  }
  loadGrapesJsEditor(){
    //this.router.navigate(['grapesjs'])
 
    let linkDialog = this.dialog.open(GrapesjsEditorComponent, {
      data: {
        createTemplate : "true"
      },
      panelClass: ['animate__animated', 'animate__slideInLeft'],
      disableClose: true,
      position: {
        left: "0%"
        //top  :"10%"
      },
      maxWidth: "90%",
      maxHeight: "100vh",
      width: "90%",
      height: "100vh"
 
    });
    linkDialog.afterClosed().subscribe((response: any) => {
    })
  }
  advanceSearchNavigator(){
    this.router.navigate(['advanceSearch'])
  }
  newDashBoardNavigator(){
    this.spinner.show();
    this.router.navigate(['/gridDashboard'])
    this.spinner.hide();
    this.dialog.closeAll()
    this.sideNav.pinShortCutDialog(false)
  }
}
